import gql from 'graphql-tag';

export default gql`
  fragment itemFragment on Item {
    id
    order_id
    store {
      id
      name
    }
    store_id
    reference_item_id
    title
    type
    link
    quantity
    units_per_pack
    notes
    taxon_name
    taxon_name_ar
    store_price
    store_price_discount
    store_currency_code
    customs_category {
      id
      name
      name_ar
      customs
      clearance_charges
    }
    customs
    shipping_intl
    shipping_us
    tax
    total_price
    small_photo_url
    photo {
      source_url
      url_thumb
      url_small
      url_xsmall
    }
    in_usd {
      store_price_usd
      total_price
      unit_price
      clearance_charges
      fees
      customs
    }
    in_currency {
      store_price_usd
      total_price
      unit_price
      clearance_charges
    }
    selected_variations {
      name
      value
    }
    actual_weight
    estimated_weight_kg
    measured_weight_kg
    data_extractor_result {
      asin
      is_pack
      current_variation {
        fid
        selectors {
          name
          value
        }
        price
        shipping_cost
        image_url
        weight
      }
      parent_asin
      title
      brand
      selector_types
      sorted_selectors {
        name
        values
      }
      variations {
        fid
        selectors {
          name
          value
        }
        price
        shipping_cost
        image_url
        weight
      }
    }
    diffbot_result {
      title
      brand
      is_pack
      variations {
        price
        fid
        image_url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/graphql/itemFragment.gql.js